import React from 'react';
import { Avatar, Stack, Typography } from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';
import { useQuery } from 'react-query';
import API, { useAuth } from '@wheeebo/polaris-api';
import { SquareChip } from '../chip';
import { CircleLoader, LoadError } from '../loader';
function MemberPanel({ member, memberId, ...props }) {
    const { account } = useAuth();
    const { data, isLoading, isError } = useQuery(memberId ? API.Members.getKey(memberId) : '', () => (memberId ? API.Members.get(memberId) : undefined), { enabled: !member && !!memberId });
    if (!member) {
        if (isLoading) {
            return React.createElement(CircleLoader, null);
        }
        else if (isError) {
            return React.createElement(LoadError, null);
        }
    }
    const content = member || data;
    return (React.createElement(Stack, { direction: "row", gap: 1, sx: { display: 'flex', alignItems: 'center', cursor: 'pointer' }, ...props },
        React.createElement(Avatar, { src: content?.avatarUrl, sx: { width: 32, height: 32, backgroundColor: 'transparent' } },
            React.createElement(PersonIcon, { color: "disabled" })),
        React.createElement(Typography, { variant: "body2" }, content?.name),
        content?.id === account?.id && React.createElement(SquareChip, { label: "You", color: "primary" })));
}
export default React.memo(MemberPanel);
